import { FieldOption } from './accountTypes'

const zoomTypes: FieldOption[] = [
  { value: 'meeting', name: 'Zoom Meeting' },
  { value: 'webinar', name: 'Zoom Webinar' }
]

export default zoomTypes
